import React, { Fragment } from 'react'
import { useHero, HeroProps } from './useHero'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Pagination, Parallax } from 'swiper/modules'
import blockContentToHtml from '@sanity/block-content-to-html'
import ParticlesBackground from 'components/ParticlesBackground/ParticlesBackground'
import styles from './Hero.module.scss'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

const Hero: React.FC<HeroProps> = (props: HeroProps) => {
  const { isAr, sliderData } = useHero(props)

  return (
    <section id='hero' className={styles.hero}>
      <Swiper
        dir='rtl'
        navigation
        loop
        pagination={{
          clickable: true,
          dynamicBullets: true,
        }}
        style={
          {
            '--swiper-navigation-color':
              'color-mix(in srgb, #fff, transparent 40%)',
            '--swiper-pagination-color':
              'color-mix(in srgb, #fff, transparent 40%)',
          } as React.CSSProperties
        }
        parallax={true}
        modules={[Navigation, Pagination, Parallax]}
        className={styles.swiper}
        data-swiper-parallax='-23%'
      >
        {sliderData &&
          sliderData.length &&
          sliderData.map((slider, index) => (
            <SwiperSlide key={`home-slider-${index}`} className={styles.slide}>
              {index === 0 ? <ParticlesBackground /> : <Fragment />}
              <img
                src={slider.image}
                alt='slider image'
                className={styles.background}
                loading='lazy'
              />
              <div className={styles.content}>
                <h1 className='mb-4' data-swiper-parallax='-500'>
                  {isAr ? slider.titleAr : slider.titleEn}
                </h1>
                <div className='mb-4' data-swiper-parallax='-300'>
                  <div
                    className={styles.description}
                    dangerouslySetInnerHTML={{
                      __html: isAr
                        ? Array.isArray(slider.descriptionAr)
                          ? blockContentToHtml({
                              blocks: slider.descriptionAr,
                            })
                          : `<p>${slider.descriptionAr}</p>`
                        : Array.isArray(slider.descriptionEn)
                          ? blockContentToHtml({
                              blocks: slider.descriptionEn,
                            })
                          : `<p>${slider.descriptionEn}</p>`,
                    }}
                  ></div>
                </div>
                <div data-swiper-parallax='-100'>
                  <a
                    href={slider.button.url}
                    className={`${styles.btn} btn btn-outline-primary px-5 py-2`}
                  >
                    {isAr ? slider.button.labelAr : slider.button.labelEn}
                  </a>
                </div>
              </div>
            </SwiperSlide>
          ))}
      </Swiper>
    </section>
  )
}

export default Hero
